export function isCentralizedTrainBooking({ category, travelSubcategory, travelBookedBy }) {
  return category === "Travel" && ["Train", "Bus", "Flight"].includes(travelSubcategory) && travelBookedBy === "centralized";
}

export function isCompanyPaidHotelBlocked({ category, hotelCompanyPaid }) {
  return category === "Hotel" && !!hotelCompanyPaid;
}

export function buildNameFields(count) {
  const safeCount = Math.max(0, Number.parseInt(count || 0, 10) || 0);
  return Array.from({ length: safeCount }, () => "");
}

export function getFuelFieldValidationMessage({
  category,
  fuelVehicleType,
  fuelType,
  fuelVehicleNo,
  fuelLiters,
}) {
  if (category !== "Fuel") return "";
  if (!fuelVehicleType) return "Select personal vehicle or hired vehicle";
  if (!fuelType) return "Select fuel type";
  if (!fuelVehicleNo?.trim()) return "Enter vehicle number";
  return "";
}
